<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-row>
      <!-- COLUMNA PRINCIPAL 1 -->
      <v-col cols="12" lg="6">
        <v-card>
          <v-card-title class="d-flex justify-center text-subtitle-2">
            Niveles de configuración del sistema
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="d-flex ">
                <v-checkbox v-model="selectAll" class="ma-0 pa-0" @change="selectAllCheckboxes" label="Seleccionar todos"
                  color="success" />
                <v-spacer />
                <ButtonComp text-button="Agregar" :disabled="!nivelesSelecciondas.length" iconBut="fas fa-plus"
                  @click="aggNivel()" />
              </v-col>
              <template v-if="Niveles.length">
                <v-col cols="12" md="6" class="d-flex justify-center" v-for="nivel of Niveles" :key="nivel.id">
                  <v-card width="240">
                    <v-card-title :style="{ backgroundColor: nivel.color }">
                      <h4 class="white--text">{{ nivel.desc_nivel }}</h4>
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer />
                      <v-checkbox class="ma-0 pa-0" v-model="nivelesSelecciondas" :value="nivel.id" color="success"
                        :key="nivel.id" hide-details></v-checkbox>
                      <!-- <ButtonComp v-if="componenteEvento.agregar_submodulo" @click="aggNivel(nivel)" textButton="Agregar"
                        iconBut="fas fa-plus" /> -->
                    </v-card-actions>
                  </v-card>
                </v-col>
              </template>
              <template v-else>
                <v-col cols="12" class="d-flex justify-center">
                  <v-card outlined>
                    <v-card-text style="height: 240px" class="d-flex justify-center align-center">
                      No hay niveles configurados en el sistema
                    </v-card-text>
                  </v-card>
                </v-col>


              </template>

            </v-row>

          </v-card-text>
        </v-card>

      </v-col>
      <v-col cols="12" lg="6">
        <v-card>
          <v-card-title class="d-flex justify-center text-subtitle-2">
            Niveles del colegio
          </v-card-title>
          <v-card-text>
            <v-row>
              <template v-if="NivelesAdmin.length">
                <v-col v-for="nivel of NivelesAdmin" class="d-flex justify-center" :key="nivel.id" cols="12" sm="6" md="6"
                  >
                  <v-card width="240">
                    <v-card-title :style="{ backgroundColor: nivel.color }">
                      <h4 class="white--text">{{ nivel.desc_nivel }}</h4>
                    </v-card-title>
                    <v-card-actions>
                      <ButtonComp v-if="componenteEvento.visualizar_submodulo" @click="getAllGradosNivelAdmin(nivel)"
                        textButton="Ver Grados" iconBut="fas fa-eye" />
                      <v-spacer></v-spacer>
                      <ButtonComp v-if="componenteEvento.borrar_submodulo" @click="deleteNivel(nivel)" deleteButton
                        tooltipText="Eliminar nivel" />

                    </v-card-actions>
                  </v-card>
                </v-col>
              </template>
              <template v-else>
                <v-col cols="12">
                  <v-card outlined>
                    <v-card-text style="height: 240px" class="d-flex justify-center align-center">
                      Aún no has agregado ningún nivel al colegio
                    </v-card-text>
                  </v-card>
                </v-col>


              </template>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>

    <!-- modal agregar nivel a mantenimiento --->
    <ComunDialogComp Confirmdialog v-model="nivel_dialog" titleWindow="Confirmar" @close-modal="nivel_dialog = false"
      @cancel-item="nivel_dialog = false" @confirm-item="addNiveles">
      <template v-slot:body>
        <span>¿Está seguro de agregar este "nivel" al "colegio"?</span>
        <!-- {{ dataNivelesSeleccionadas }} -->
        <ul>
          <li v-for="nivel in dataNivelesSeleccionadas" :key="nivel.id">
            {{ nivel.desc_nivel }}
          </li>
        </ul>
        <v-progress-linear v-if="isSaving" indeterminate color="white" class="mb-0" />
        <!-- <v-chip :color="editedNiveles.color" class="white--text">
          {{ editedNiveles.desc_nivel }}
        </v-chip> -->
      </template>
    </ComunDialogComp>

    <!--------fin modal-->

    <!----------------modal agregar grados a niveles------>
    <!-- modal ver grados-->
    <ComunDialogComp v-model="modal_grados" maxWidth="400" @close-modal="modal_grados = false">
      | <template v-slot:title>
        Grados del nivel : {{ titleVerGrado }}
      </template>
      <template v-slot:body>
        <div v-if="GradosNivel.length > 0">
          <v-col cols="12" v-for="item of GradosNivel" :key="item.id">
            <v-row align="center" class="spacer" no-gutters>
              <v-col cols="1">
                <v-icon color="primary">fa-check</v-icon>
              </v-col>

              <v-col>
                <v-chip color="yellow lighten-4" class="ml-2 black--text" label small>
                  <h3>{{ item.desc_grado }}</h3>
                </v-chip>
              </v-col>
            </v-row>

            <v-divider></v-divider>
          </v-col>
        </div>

        <v-col cols="12" v-else>
          <v-alert color="#ffbc00" icon="fas fa-exclamation-triangle" dark border="left" prominent elevation="5" dense>
            <span class="font-weight-black">
              No hay "grados" registrados en este "nivel"
            </span>
          </v-alert>
        </v-col>
      </template>
    </ComunDialogComp>


    <!-- modal - delete -->
    <confirm @aceptar="deleted" titleWindow="Eliminar nivel" @cancelar="clear_confirm" :title="confirm.title"
      :active="confirm.active" />
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";

import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';

export default {
  components: {
    ButtonComp,
    ComunDialogComp
  },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 13, id_modulo: 6 },

    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    nivelesSelecciondas: [],
    selectAll: false,
    isSaving: false,
    // modal deleted
    confirm: {
      nivel: {},
      title: "",
      active: false,
    },
    Niveles: [],
    NivelesAdmin: [],
    mostrarMensaje: false,

    // modal agregar nivel
    nivel_dialog: false,
    editedNiveles: [],

    //modal ver grados
    titleVerGrado: "",
    modal_grados: false,
    GradosNivel: [],

    parametros: {
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_colegio_adm_nivel: sessionStorage.id_colegio,
    },

    nivelParams: {
      id_colegio: sessionStorage.id_colegio,
      id_anio_lectivo: sessionStorage.id_ano_lectivo,
    },
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    ...mapState({ Grados: (state) => state.nivelesGrados.grados }),

    dataNivelesSeleccionadas() {
      return this.Niveles.filter(e => this.nivelesSelecciondas.includes(e.id))
    }
  },

  mounted() {
    this.getAllNivelesAdmin();
    this.getNivelesMantenimiento();
  },

  created() {
    this.actualizarParamentro();

    this.$store.dispatch("nivelesGrados/getAllGrados");
    //this.$store.dispatch('nivelesGrados/getAllNiveles');
  },



  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    /* //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviar']),

            enviarMensaje(a, b, c) {
                this.mensaje.mensaje = a
                this.mensaje.tipo = b
                this.mensaje.tiempo = c
                this.mensaje.activate = true
                this.setEnviar(this.mensaje)
            }, */
    ////////////////////////////////////////////////////////

    ...mapActions("nivelesGrados", ["getAllGrados"]),

    selectAllCheckboxes() {
      if (this.selectAll) {
        // Si el checkbox "Seleccionar Todos" está marcado, seleccionar todos los niveles
        this.nivelesSelecciondas = this.Niveles.map((nivel) => nivel.id);
      } else {
        // Si el checkbox "Seleccionar Todos" está desmarcado, deseleccionar todos los niveles
        this.nivelesSelecciondas = [];
      }
    },


    //---------Niveles de mantenimiento -------
    async getNivelesMantenimiento() {
      try {
        let response = await axios.post(
          "/administrativo/nivel/mant/filt/",
          this.nivelParams
        );
        this.Niveles = response.data;
        //console.log(this.Niveles)
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //-----------obtener niveles admin-------------------
    async getAllNivelesAdmin() {
      this.mostrarMensaje = false;
      let params = this.parametros;
      try {
        let response = await axios.post("/administrativo/nivel/niveladmin/", params);
        this.NivelesAdmin = response.data;

        if (this.NivelesAdmin.length === 0) {
          this.mostrarMensaje = true;
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    // clear data modal deleted
    clear_confirm() {
      this.confirm.nivel = {};
      this.confirm.title = "";
      this.confirm.active = false;
    },

    async limpiarForm() {
      this.editedNiveles = {
        id_colegio: this.datoLogin.id_colegio,
        id_usuario: this.datoLogin.id,
        id_nivel: 0,
        estado_nivel: 1,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        desc_nivel: "",
      };
    },

    //------confirmar el nivel agregar -----
    aggNivel() {
      this.limpiarForm();
      this.nivel_dialog = true;
      // this.editedNiveles.id_nivel = nivel.id;
      // this.editedNiveles.desc_nivel = nivel.desc_nivel;
      // this.editedNiveles.color = nivel.color;
    },

    //-----------modal agregar nivel-------------------------
    async addNiveles() {
      this.isSaving = true
      // let params = this.editedNiveles;
      // console.log('Los niveles seleccionados son', this.dataNivelesSeleccionadas);
      try {
        const areaBase = {
          id_usuario: sessionStorage.id,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_colegio: sessionStorage.id_colegio,
        }
        const arrayPromesas = []
        this.dataNivelesSeleccionadas.forEach(nivel => {

          const params = {
            ...areaBase,
            id_nivel: nivel.id
          }
          arrayPromesas.push(axios.post("/administrativo/nivel", params))

        });
        // let resp = await axios.post("/administrativo/nivel", params);
        await Promise.all(arrayPromesas)
        this.isSaving = false
        this.getAllNivelesAdmin();
        this.getNivelesMantenimiento();

        this.limpiarForm();
        this.nivel_dialog = false;
        this.nivelesSelecciondas.splice(0)


        this.setEnviarMens({
          tipo: "S",
          mensaje: `¡Información creada con éxito!`,
          tiempo: null,
        });
        //console.log(response);
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //----------------traer grados administrativo-------------
    async getAllGradosNivelAdmin(nivel) {
      //var id = nivel.id_nivel_adm_nivel
      this.titleVerGrado = nivel.desc_nivel;
      let params = {
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_colegio: sessionStorage.id_colegio,
        id_nivel: nivel.id_nivel_adm_nivel,
      };
      //console.log('mi id===>'+JSON.stringify(params))
      try {
        let response = await axios.post(
          "/administrativo/grado/gradosNivelAdmin/",
          params
        );
        this.GradosNivel = response.data;
        this.modal_grados = true;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //-- METODO QUE PERMITE ELIMINAR UN NIVEL
    //-- SIEMPRE Y CUANDO NO SE ENCUENTRE ASOCIADO A OTRO REGISTRO EN LA BASE DE DATOS
    //------------borrar nivel -------------
    async deleteNivel(nivel) {
      this.confirm.nivel = nivel;
      this.confirm.title = "¿Está seguro de eliminar este registro?";
      this.confirm.active = true;
    },

    async deleted() {
      let params = {
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_colegio: sessionStorage.id_colegio,
        id_nivel: this.confirm.nivel.id_nivel_adm_nivel,
      };
      let res = await axios.post("/administrativo/grado/gradosNivelAdmin/", params);
      let datos = res.data;
      if (datos.length == 0) {
        await axios
          .delete("/administrativo/nivel/" + this.confirm.nivel.id)
          .then((response) => {
            if (response.data.success) {
              this.getAllNivelesAdmin();
              this.getNivelesMantenimiento();
              this.nivel_dialog = false;
              this.clear_confirm();
              this.setEnviarMens({
                tipo: "S",
                mensaje: response.data.message,
                tiempo: null,
              });
            } else {
              this.setEnviarMens({
                tipo: "E",
                mensaje: response.data.message,
                tiempo: null,
              });
            }
          });
      } else {
        this.clear_confirm();

        this.setEnviarMens({
          tipo: "W",
          mensaje: "No se puede eliminar el nivel ya que tiene grados asociados",
          tiempo: null,
        });
      }

      //this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
    },
  },
};
</script>
